export default __webpack_public_path__ + "static/media/placeholder9.e2fa5c7f.jpg";